// src/App.tsx
import  React, { useState } from 'react';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import StatsChart from '../components/StatsChart';
import NbBateauxChart from '../components/chart/NbBateauxChart';
import PlacesParPortStackedBar from '../components/chart/PlacesParPortStackedBar';
import DoughnutQuantitesFamille from '../components/chart/DoughnutQuantitesFamille';
import { useSettingsLocal } from '../hooks/useSettingsLocal';
import DoughnutCategorieBat from '../components/chart/DoughnutCategorieBat';
import DoughnutTypeBat from '../components/chart/DoughnutTypeBat';
import {  MasonryGrid, MasonryItem } from '../components/layout/Masonry';
import DynamicQueryCard from '../components/DynamicQueryCard';


export default function DynamicChartPage() {

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    return (
        <div className="min-h-svh flex">
          <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

          <div className="flex-1 lg:ml-64">
            <Header onOpenSidebar={() => setIsSidebarOpen(true)} />

            <main className="p-6 pt-20 bg-gray-50 dark:bg-darkMode">
              
                  <DynamicQueryCard />
                
            </main>
          </div>
        </div>
      );
}
  